import { styled } from '@ori-ui/mui';
import type { VFC } from 'react';

import { AboutIcon } from './About/AboutIcon';
import { BurgerMenuToggle } from './BurgerMenu/BurgerMenuToggle';
import { JoinIcon } from './Join/JoinIcon';
import { SearchIcon } from './SearchIcon';
import { UserIcon } from './UserIcon';
import { VipOrderIcon } from './VipOrder';
import { useMobileWidth } from '~/hooks';

const LeftActionsSectionRoot = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  maxWidth: 130,

  [theme.breakpoints.up('sm')]: {
    maxWidth: 'none',
  },
}));

export const LeftActionsSection: VFC = () => {
  const isMobile = useMobileWidth();

  return (
    <LeftActionsSectionRoot>
      <BurgerMenuToggle />
      {isMobile ? <SearchIcon /> : null}
      {isMobile ? <VipOrderIcon /> : null}
      {!isMobile && <UserIcon />}
      {!isMobile && <AboutIcon />}
      {!isMobile && <JoinIcon />}
    </LeftActionsSectionRoot>
  );
};
